import RouteConfig from './config/RouteConfig';
import 'edge/quoteandbind/common/app';
import 'edge/policyjob/app';
import 'edge/platform/widgets/time/module';
import 'angularRouter';
import EditPolicyAddress from './directives/editPolicyAddress';
import EditNamedInsured from './directives/editNamedInsured';
import AdditionalNamedInsured from './directives/additionalNamedInsured';
import EditLocation from './directives/editLocation';
import QuoteService from './services/QuoteService';
import FilterDirective from 'customerEdge/gateway/filterDirective/Filter';

export default angular.module('edge.quoteandbind.wc.app', ['edge.quoteandbind.common.app', 'edge.policyjob.app', 'edge.platform.widgets.ui.time']).config(['$stateProvider', 'state_plugin_config', function ($stateProvider, RootStateConfig) {
    var states = new RouteConfig(RootStateConfig);
    for (var stateName in states) {
        if (states.hasOwnProperty(stateName)) {
            console.log('wc app.js statename=' + stateName + ' ' + states.hasOwnProperty(stateName));
            $stateProvider.state(stateName, states[stateName]);
        }
    }
}]).directive('gwEditPolicyAddress', EditPolicyAddress).directive('gwEditNamedInsured', EditNamedInsured).directive('gwEditLocation', EditLocation).directive('gwAdditionalNamedInsured', AdditionalNamedInsured).directive('gwFilterRecords', FilterDirective).factory('quoteService', QuoteService);


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=quoteandbind_lob&equals=wc!./app/customer/js/src/edge/quoteandbind/wc/app.js
// module id = 485
// module chunks = 0